<mat-card>
  <div class="container-fluid marginHeader">

    <form class="form-group" [formGroup]="formSearch" (ngSubmit)="submitForm()">

      <div class="row">
        <div class="col-md-4 item-filter pt7">
          <mat-form-field class="wd-100 customSelect" [floatLabel]="'auto'">
            <mat-label>Nome do Arquivo</mat-label>
            <input matInput formControlName="fileName">
          </mat-form-field>
        </div>

        <div class="col-md-2 item-filter">
          <ng-select [items]="statusObj" [selectOnTab]="true" placeholder="Status" bindLabel="description"
            bindValue="value" formControlName="fileStatus" class="customSelect" [searchable]="false" [clearable]="false"
            style="padding-bottom: 0px !important;"
            appearance="outline">
          </ng-select>
        </div>

        <!--#Datepiker-->

        <div class="col-md-2 pt7">
            <mat-form-field appearance="fill">
                <mat-label>Data inicial</mat-label>
                <input matInput [matDatepicker]="picker" [(ngModel)]="initialDate"
                    formControlName="initialDate">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

        </div>
        <div class="col-md-2 pt7">
            <mat-form-field appearance="fill">
                <mat-label>Data final</mat-label>
                <input matInput [matDatepicker]="endDatepicker" [(ngModel)]="endDate"
                    formControlName="endDate">
                <mat-datepicker-toggle matSuffix [for]="endDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #endDatepicker></mat-datepicker>
            </mat-form-field>
        </div>
        <!--/#Datepiker-->

        <div class="col-md-2 item-filter text-center">
          <button type="submit" class="btn btn-primary mr-2"><i class="flaticon2-search"></i>Filtrar</button>
        </div>
      </div>
    </form>
  </div>
  <hr />
  <!-- <div *ngIf="resOk && !noData">
    <custom-list [cols]="tableColsMock" [data]="data" [config]="configTable" (reloadTable)=reloadingForAction($event)>
    </custom-list>
  </div> -->

  <div *ngIf="resOk && data.length > 0" style="margin-top: 15px">
    <simple-list [data]="data" [config]="configTable" (reloadTable)="reloadingForAction($event)">
    </simple-list>
 </div>

  <div *ngIf="resOk && noData">
    <mat-card>
      <p class="notData">Não existem dados a serem carregados!</p>
    </mat-card>
  </div>

  <loader></loader>
</mat-card>
